import {Subject} from "rxjs/Subject";
import {Observable} from "rxjs/Observable";

export function asObservable( subject: any ) {
    return new Observable(fn => subject.subscribe(fn));
}



// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/services/asObservable.ts